import { render, staticRenderFns } from "./ChatWithBusiness.vue?vue&type=template&id=e402416e&scoped=true&"
import script from "./ChatWithBusiness.vue?vue&type=script&lang=js&"
export * from "./ChatWithBusiness.vue?vue&type=script&lang=js&"
import style0 from "./ChatWithBusiness.vue?vue&type=style&index=0&id=e402416e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e402416e",
  null
  
)

export default component.exports